import { Component } from '@angular/core';
import { ReportShareComponent } from '../../report-share.component';

@Component({
  selector: 'app-coachee-score-summary',
  templateUrl: './coachee-score-summary.component.html'
})
export class CoacheeScoreSummaryComponent extends ReportShareComponent {

  get coachingStyleHeight(): number {
    return this.download ? 330 : 400
  }
  
  get directIndirectHeight(): number {
    return this.download ? 130 : 150
  }

}
